module.exports = __webpack_public_path__ + "img/LuojiaSwarm2.e60b060c.png";